import type {Result, UseCase} from 'framework';
import type {AssistantProposal} from '../../domain/assistant-proposal';
import type {AssistantError} from '../../domain/errors';
import type {AssistantRepository, ProposalDecisionInput} from '../ports/assistant.repository';

export class DiscardProposal implements UseCase<[ProposalDecisionInput], AssistantProposal> {
  constructor(private readonly repository: AssistantRepository) {}

  execute(input: ProposalDecisionInput): Promise<Result<AssistantProposal, AssistantError>> {
    return this.repository.discardProposal(input);
  }
}
